.copyable-text-container {
  cursor: pointer;
  display: flex;
  position: relative;
  width: fit-content;
}

.copyable-text-copy-button {
  align-items: center;
  background-color: var(--color-grey-300);
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  display: flex;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  gap: 0.25rem;
  inset: calc(-0.25rem + 1px) auto auto -0.5rem;
  justify-content: center;
  padding: 0.25rem 0.5rem;
  position: absolute;
  transition: opacity 150ms ease;
  white-space: nowrap;
  z-index: 10;
}

.copyable-text-container:focus-within {
  outline: none;
}

.copyable-text-copy-visually-hidden {
  border-width: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}
